module.exports = __webpack_public_path__ + "media/images/riders/small/ELISABETH_BRANDAU-3165c573ed1829b5226de181e0e96ab0.png";